export default fn => e => {
  e.preventDefault()
  fn(e)
}



// WEBPACK FOOTER //
// ./src/utils/preventDefault.js